import { FormType } from './form-type';

export class Dosage {
  form: string;
  type: FormType[];
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/services/medispan/models/dosage.ts